import { render, staticRenderFns } from "./CmfFooter.vue?vue&type=template&id=9ed6a184&scoped=true"
import script from "./CmfFooter.vue?vue&type=script&lang=js"
export * from "./CmfFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed6a184",
  null
  
)

export default component.exports